import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon, IconDefinition } from "@fortawesome/fontawesome-svg-core";

import {
  faHome,
  faUser,
  faFolder,
  faEnvelope,
  faBook,
  faUserGear,
} from "@fortawesome/free-solid-svg-icons";
import {
  faGraduationCap,
  faMedal,
  faTrophy,
  faTasks,
  faCogs,
  faList,
  faBriefcase,
  faCertificate,
  faLightbulb,
  faBlog,
  faFolderOpen,
  faVideo,
} from "@fortawesome/free-solid-svg-icons";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";

import {
  faShoppingCart,
  faLaptop,
  faMobileAlt,
  faServer,
  faDatabase,
  faLaptopCode,
  faUsersGear,
} from "@fortawesome/free-solid-svg-icons";

interface AboutSectionProps {
  title: string;
  iconName?: string;
}

const iconMap: { [key: string]: IconDefinition } = {
  home: faHome,
  user: faUser,
  folder: faFolder,
  envelope: faEnvelope,
  graduation: faGraduationCap,
  medal: faMedal,
  trophy: faTrophy,
  task: faTasks,
  cogs: faCogs,
  faList: faList,
  briefcase: faBriefcase,
  certificate: faCertificate,
  lightbulb: faLightbulb,
  blog: faBlog,
  folderOpen: faFolderOpen,
  video: faVideo,
  youtube: faYoutube,
  book: faBook,
  shopingCart: faShoppingCart,
  userGear: faUsersGear,
  laptopCode: faLaptopCode,
};

const AboutSection: React.FC<AboutSectionProps> = ({ title, iconName }) => {
  return (
    <div className="bg-white shadow-md rounded-lg  mb-2 w-full   text-center">
      <h1 className="text-3xl font-bold text-gray-800 mb-2">
        <FontAwesomeIcon
          icon={iconName == undefined ? faHome : iconMap[iconName]}
          className="mr-2"
        />
        {title}
      </h1>
    </div>
  );
};

export default AboutSection;
